import React from "react";
import ViewDetails from "./ViewDetails";
import Skeleton from "./ViewDetails/Skeleton";

const ViewOnboardingBranch = ({viewLoading,branchRecodes,BranchUserList}) => {

    return (
        <>
            {viewLoading ? <Skeleton /> : <ViewDetails branchRecodes={branchRecodes} BranchUserList={BranchUserList}/>}
        </>
    );
}

export default ViewOnboardingBranch;
